import { logger } from "../core/logger";
import { THEME_EVENTS, publish } from "../../shared/events";

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      if (!target) return;
      this.currentVariant = this.getVariantData(target.id);
      if (!this.currentVariant) return;
      this.updateSelectedSwatchValue(event);

      console.log("target", target);
      console.log("target.id", target.id);
      console.log("currentVariant", this.currentVariant);
      console.log("selectedOptionValues", this.selectedOptionValues);

      publish(THEME_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        ?.querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(".product-form__input")
        ?.querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  getVariantData(inputId) {
    const variantDataElement = this.getVariantDataElement(inputId);
    if (!variantDataElement) return null;
    try {
      return JSON.parse(variantDataElement.textContent);
    } catch (error) {
      logger?.error?.("VariantSelects: invalid variant JSON", {
        inputId,
        error,
      });
      return null;
    }
  }

  getVariantDataElement(inputId) {
    const safeInputId = String(inputId).trim();
    return this.querySelector(
      `script[type="application/json"][data-resource="${CSS.escape(safeInputId)}"]`,
    );
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select, fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }
}
if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}
